import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { ManageUserProvider } from '../contexts/manageUser';
import { RoutingContextType } from './types';

export function ManageUserRoutes() {
  const outletValue: RoutingContextType = useOutletContext();
  const { id } = useParams() as { id: string };

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <ManageUserProvider id={id}>
      <Outlet context={contextValue} />
    </ManageUserProvider>
  );
}
